<div [dir]="textDir" class="big-parent h-100">
  <div class="loading-wrapper" *ngIf="loaderService?.loading">
    <app-loading></app-loading>
  </div>
  <router-outlet></router-outlet>
</div>
